import { action } from 'typesafe-actions';
import { KpiEAETypes, IKpi } from './types';

export const loadRequest = (cd: number, inscricao: number[], card: string, agrupar: number) =>
  action(KpiEAETypes.LOAD_REQUEST, {
    cd,
    agrupar,
    card,
    inscricao,
  });

export const loadSuccess = (data: IKpi[]) => action(KpiEAETypes.LOAD_SUCCESS, { data });

export const loadFailure = () => action(KpiEAETypes.LOAD_FAILURE, {});
